module.exports = __webpack_public_path__ + "img/dashboard-sample.af325968.png";